/**
 * MOD Animations by frames - configured in LYRA
 */
import { 
	immediateEntry, stageLeave,
	stageMultipleLayerEntry, stageMultipleLayerLeave
} from './moa.animations.helper';

/**
 * Animation Object
 */
export const animations: any = {
	'moa-frame-not-approved': () => {
		return {
			enter: () => immediateEntry('.js-moa-frame-not-approved'),
			leave: () => stageLeave('.js-moa-frame-not-approved'),
		}
	},
	'moa-frame-intro-screen-2': () => {
		return {
			enter: () => immediateEntry('.js-moa-frame-intro-screen-2'),
			leave: () => stageLeave('.js-moa-frame-intro-screen-2'),
		}
	},
	'moa-frame-intro-screen-3': () => {
		return {
			enter: () => immediateEntry('.js-moa-frame-intro-screen-3'),
			leave: () => stageLeave('.js-moa-frame-intro-screen-3'),
		}
	},
	'moa-frame-human-organs': () => {
		return {
			enter: () => immediateEntry('.js-moa-frame-human-organs'),
			leave: () => stageLeave('.js-moa-frame-human-organs'),
		}
	},
	'moa-frame-virus-entry': () => {
		return {
			enter: () => immediateEntry('.js-moa-frame-virus-entry'),
			leave: () => stageLeave('.js-moa-frame-virus-entry'),
		}
	},
	'moa-frame-protein-created': () => {
		return {
			enter: () => immediateEntry('.js-moa-frame-protein-created'),
			leave: () => stageLeave('.js-moa-frame-protein-created'),
		}
	},
	'moa-frame-protein-detach': () => {
		return {
			enter: () => immediateEntry('.js-moa-frame-protein-detach'),
			leave: () => stageLeave('.js-moa-frame-protein-detach'),
		}
	},
	'moa-frame-purple-rna-created': () => {
		return {
			enter: () => immediateEntry('.js-moa-frame-purple-rna-created'),
			leave: () => stageLeave('.js-moa-frame-purple-rna-created'),
		}
	},
	'moa-frame-rna-move': () => {
		return {
			enter: () => immediateEntry('.js-moa-frame-rna-move'),
			leave: () => stageLeave('.js-moa-frame-rna-move'),
		}
	},
	'moa-frame-purple-rna-coiled': () => {
		return {
			enter: () => immediateEntry('.js-moa-frame-purple-rna-coiled'),
			leave: () => stageLeave('.js-moa-frame-purple-rna-coiled'),
		}
	},
	'moa-frame-virus-package': () => {
		return {
			enter: () => immediateEntry('.js-moa-frame-virus-package'),
			leave: () => stageLeave('.js-moa-frame-virus-package'),
		}
	},
	'moa-frame-protein-chain-break': () => {
		return {
			enter: () => stageMultipleLayerEntry('.js-moa-frame-protein-chain-break', 'stage-2'),
			leave: () => stageMultipleLayerLeave('.js-moa-frame-protein-chain-break'),
		}
	},
	'moa-frame-protein-chain-svg': () => {
		return {
			enter: () => {
				stageMultipleLayerEntry('.js-moa-frame-protein-chain-break', 'stage-3');
				immediateEntry('.js-moa-frame-protein-chain-svg');
			},
			leave: () => {
				stageMultipleLayerLeave('.js-moa-frame-protein-chain-break');
				stageLeave('.js-moa-frame-protein-chain-svg');
			}
		}
	},
	'moa-frame-protein-rna': () => {
		return {
			enter: () => immediateEntry('.js-moa-frame-protein-rna'),
			leave: () => stageLeave('.js-moa-frame-protein-rna'),
		}
	},
	'moa-frame-protein-mpro': () => {
		return {
			enter: () => immediateEntry('.js-moa-frame-protein-mpro'),
			leave: () => stageLeave('.js-moa-frame-protein-mpro'),
		}
	},
	'moa-frame-unable-cut': () => {
		return {
			enter: () => immediateEntry('.js-moa-frame-unable-cut'),
			leave: () => stageLeave('.js-moa-frame-unable-cut'),
		}
	},
	'moa-frame-callout': () => {
		return {
			enter: () => immediateEntry('.js-moa-frame-callout'),
			leave: () => stageLeave('.js-moa-frame-callout'),
		}
	},
	'moa-frame-nirm-screen-3': () => {
		return {
			enter: () => immediateEntry('.js-moa-frame-nirm-screen-3'),
			leave: () => stageLeave('.js-moa-frame-nirm-screen-3'),
		}
	},
	'moa-frame-conj-screen-1': () => {
		return {
			enter: () => stageMultipleLayerEntry('.js-moa-frame-conj-screen-1', 'stage-1'),
			leave: () => stageLeave('.js-moa-frame-conj-screen-1')
		}
	},
	'moa-frame-molecules': () => {
		return {
			enter: () => {
				stageMultipleLayerEntry('.js-moa-frame-conj-screen-1', 'stage-2'),
				immediateEntry('.js-moa-frame-molecules');
			},
			leave: () => {
				stageLeave('.js-moa-frame-conj-screen-1');
				stageLeave('.js-moa-frame-molecules');
			}
		}
	},
	'moa-frame-person-cup': () => {
		return {
			enter: () => immediateEntry('.js-moa-frame-person-cup'),
			leave: () => stageLeave('.js-moa-frame-person-cup'),
		}
	},
	'moa-credits': () => {
		return {
			enter: () => immediateEntry('.js-moa-credits'),
			leave: () => stageLeave('.js-moa-credits'),
		}
	}
};